export default __webpack_public_path__ + "static/media/hero-ipad.016700b2.jpg";